/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Signal_Tech_MetaInputs */

const en_landing_signal_tech_meta = /** @type {(inputs: Landing_Signal_Tech_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tech • 21 clients matched • High conviction`)
};

/**
* | output |
* | --- |
* | "Tech • 21 clients matched • High conviction" |
*
* @param {Landing_Signal_Tech_MetaInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_signal_tech_meta = /** @type {((inputs?: Landing_Signal_Tech_MetaInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Signal_Tech_MetaInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_signal_tech_meta(inputs)
});